import Vue from 'vue';
import Router from 'vue-router';

import StartPage from '@/pages/welcome/StartPage';
import PasswordLostPage from '@/pages/welcome/PasswordLostPage';
import LoginPage from '@/pages/welcome/LoginPage';

import OnboardingPage from '@/pages/userProfile/OnboardingPage';
import CourtagenPage from '@/pages/userProfile/CourtagenPage';
import BenutzerProfilPage from '@/pages/userProfile/BenutzerProfilPage';
import RegisterPage from '@/pages/userProfile/RegisterPage';

import PrivatPage from '@/pages/angebotsrechner/PrivatPage';
import KomedexPage from '@/pages/angebotsrechner/KomedexPage';
import LandwirtschaftPage from '@/pages/angebotsrechner/LandwirtschaftPage';
import GewerbeAngebotPage from '@/pages/angebotsrechner/GewerbeAngebotPage';

import SchadenPage from '@/pages/kundenverwaltung/SchadenPage';
import AngebotePage from '@/pages/kundenverwaltung/AngebotePage';
import BestandPage from '@/pages/kundenverwaltung/BestandPage';
import OffeneAntraegePage from '@/pages/kundenverwaltung/OffeneAntraegePage';
import AntraegeSearchPage from '@/pages/kundenverwaltung/AntraegeSearchPage';
import BestanddetailPage from '@/pages/kundenverwaltung/BestanddetailPage';
import SchadenDetailPage from '@/pages/kundenverwaltung/SchadenDetailPage';
import AenderungsantragPage from '@/pages/kundenverwaltung/AenderungsantragPage';
import AenderungUmfangPage from '@/pages/kundenverwaltung/AenderungUmfangPage';

import PrivatkundenPage from '@/pages/produkte/PrivatkundenPage';
import GewerbePage from '@/pages/produkte/GewerbePage';
import AerztePage from '@/pages/produkte/AerztePage';
import LandwirtePage from '@/pages/produkte/LandwirtePage';
import SoforthilfePage from '@/pages/produkte/SoforthilfePage';

import OnlineschulungPage from '@/pages/vertriebsunterstuetzung/OnlineschulungPage';
import RechtaktuellPage from '@/pages/vertriebsunterstuetzung/RechtaktuellPage';
import SepaPage from '@/pages/vertriebsunterstuetzung/SepaPage';
import VerkaufshilfenPage from '@/pages/vertriebsunterstuetzung/VerkaufshilfenPage';
import MaklerservicePage from '@/pages/vertriebsunterstuetzung/MaklerservicePage';
import ProzesskostenrechnerPage from '@/pages/vertriebsunterstuetzung/ProzesskostenrechnerPage';

import AuszeichnungenPage from '@/pages/aboutUs/AuszeichnungenPage';
import UnternehmenPage from '@/pages/aboutUs/UnternehmenPage';
import PressePage from '@/pages/aboutUs/PressePage';

import NotFoundPage from '@/pages/NotFoundPage';
import NotAllowedPage from '@/pages/NotAllowedPage';
import MaklerActivationPage from '@/pages/kundenverwaltung/MaklerActivationPage';
import { checkServerFrontendVersion } from '@/helper/versionCheck';

Vue.use(Router);

const router = new Router({
  scrollBehavior(to) {
    return to.fullPath.match(/^\/productinfo\/product[0-9]$/) ? false : { x: 0, y: 0 };
  },
  //mode: 'history',
  routes: [

    //Welcome
    {
      path: '',
      name: 'Root',
      component: StartPage,
      props: true
    },
    {
      path: '/start',
      name: 'StartPage',
      component: StartPage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/passwordlost',
      name: 'PasswordLostPage',
      component: PasswordLostPage
    },

    //Benutzerprofil
    {
      path: '/register',
      name: 'RegisterPage',
      component: RegisterPage
    },
    {
      path: '/onboarding',
      name: 'OnboardingPage',
      component: OnboardingPage
    },
    {
      path: '/benutzerprofil',
      name: 'BenutzerProfil',
      component: BenutzerProfilPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/courtagen',
      name: 'Courtagen',
      component: CourtagenPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/logout',
      name: 'Abmelden',
      component: StartPage,
      props: { doLogout: true }
    },

    //Angebotsrechner
    {
      path: '/privatkunden',
      name: 'Privatkunden',
      component: PrivatPage,
      beforeEnter: iat_guard
    },
    {
      path: '/gewerbekundenangebot',
      name: 'Gewerbekunden',
      component: GewerbeAngebotPage,
      props: true,
      beforeEnter: gewerbe_guard
    },
    {
      path: '/komedex',
      name: 'Aerzte',
      component: KomedexPage,
      props: true,
      beforeEnter: gewerbe_guard
    },
    {
      path: '/landwirtschaft',
      name: 'Landwirtschaft',
      component: LandwirtschaftPage,
      props: true
      // iat guard is done in linked target page internally for Landwirtschaft
    },

    //Produkte
    {
      path: '/produkte/privatkunden',
      name: 'PrivatkundenPage',
      component: PrivatkundenPage
    },
    {
      path: '/produkte/privatkunden/yolig',
      name: 'PrivatkundenPagenYolig',
      query: 'test',
      component: PrivatkundenPage
    },
    {
      path: '/produkte/privatkunden/sus',
      name: 'PrivatkundenPageSuS',
      component: PrivatkundenPage
    },
    {
      path: '/produkte/gewerbe',
      name: 'GewerbePage',
      component: GewerbePage
    },
    {
      path: '/produkte/aerzte',
      name: 'AerztePage',
      component: AerztePage
    },
    {
      path: '/produkte/landwirte',
      name: 'LandwirtePage',
      component: LandwirtePage
    },
    {
      path: '/soforthilfe',
      name: 'SoforthilfePage',
      component: SoforthilfePage
    },

    //Kundenverwaltung
    {
      path: '/angebote',
      name: 'Angebote',
      component: AngebotePage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/offeneAntraege',
      name: 'OffeneAntraegePage',
      component: OffeneAntraegePage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/antragssuche',
      name: 'AntraegeSearchPage',
      component: AntraegeSearchPage,
      beforeEnter: checkAuth_guard()
    },
    {
      path: '/makleractivation',
      name: 'MaklerActivationPage',
      component: MaklerActivationPage,
      beforeEnter: checkAuth_guard()
    },
    {
      path: '/bestand',
      name: 'Bestand',
      component: BestandPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/bestandDetails/:vertragsnummer',
      name: 'BestandDetailPage',
      component: BestanddetailPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/bestandDetails/:vertragsnummer/:vmnr',
      name: 'VLBestandDetailPage',
      component: BestanddetailPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/schaden',
      name: 'Schaden',
      component: SchadenPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/schadendetails/:vertragsnummer',
      name: 'SchadenDetailPage',
      component: SchadenDetailPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/schadendetails/:vertragsnummer/:vmnr',
      name: 'VLSchadenDetailPage',
      component: SchadenDetailPage,
      beforeEnter: checkAuth_guard('NotAllowedPage')
    },
    {
      path: '/aenderungsantrag/:vertragsnummer',
      name: 'AenderungsantragPage',
      component: AenderungsantragPage,
      props: { statePath: 'editContract' }
    },
    {
      path: '/aenderungsantrag/:nummer/umfang/:art',
      name: 'AenderungUmfangPage',
      component: AenderungUmfangPage
    },

    //Vertriebsunterstützung
    {
      path: '/vertriebsunterstuetzung/maklerservice',
      name: 'MaklerservicePage',
      component: MaklerservicePage
    },
    {
      path: '/vertriebsunterstuetzung/verkaufshilfen',
      name: 'VerkaufshilfenPage',
      component: VerkaufshilfenPage
    },
    {
      path: '/vertriebsunterstuetzung/rechtAktuell',
      name: 'RechtaktuellPage',
      component: RechtaktuellPage
    },
    {
      path: '/vertriebsunterstuetzung/onlineSchulung',
      name: 'OnlineschulungPage',
      component: OnlineschulungPage
    },
    {
      path: '/vertriebsunterstuetzung/prozesskostenrechner',
      name: 'ProzesskostenrechnerPage',
      component: ProzesskostenrechnerPage
    },
    {
      path: '/vertriebsunterstuetzung/SEPA',
      name: 'SepaPage',
      component: SepaPage
    },

    //Über uns
    {
      path: '/unternehmen',
      name: 'UnternehmenPage',
      component: UnternehmenPage
    },
    {
      path: '/presse',
      name: 'PressePage',
      component: PressePage
    },
    {
      path: '/auszeichnungen',
      name: 'AuszeichnungenPage',
      component: AuszeichnungenPage
    },

    // "Not Allowed" Page
    {
      path: '/notallowed/:messageid?',
      name: 'NotAllowedPage',
      component: NotAllowedPage,
      props: true
    },

    //Page Not Found
    {
      path: '*',
      name: 'NotFoundPage',
      component: NotFoundPage
    }
  ]
});

import store from '@/store';
import dummyUser from "@/store/dummyData/dummyUser";
// eslint-disable-next-line
import de from 'vee-validate/dist/locale/de';

function iat_guard (to, from, next) {
  if (store.getters.isIatUser) {
    return next({
      name: 'NotAllowedPage',
      params: { messageid: "iat" }
    });
  } else {
    return next();
  }
}

function gewerbe_guard (to, from, next) {
  if (store.getters.isIatUser) {
    return next({
      name: 'NotAllowedPage',
      params: { messageid: "iat" }
    });
  } else if (!store.getters.checkPageAuthorization(to.name)) {
    return next({
      name: 'NotAllowedPage'
    });
  } else {
    return next();
  }
}

/**
 * Creates route guard checking user authorization.
 * If authorization check fails, user is forwarded to "alternativeTarget" instead. If alternativeTarget is not set,
 * navigation is canceled, user stays on previous page.
 *
 * @param alternativeTarget target for navigation if authorization fails
 */
function checkAuth_guard (alternativeTarget) {
  return function (to, from, next) {
    if (store.getters.checkPageAuthorization(to.name)) {
      return next();
    } else {
      if (alternativeTarget) {
        return next({ name: alternativeTarget });
      } else {
        return next(false);
      }
    }
  };
}

router.beforeEach(async (to, from, next) => {
  try {
        await checkServerFrontendVersion(store.state.env?.versioninfo);
      } catch (error) {
        console.error('Version-Check fehlgeschlagen:', error);
      }
  // for all routes except landing page and login check authorization
  if (to.path === "/" || to.path === "/login" || to.path === "/register" || to.path === "/passwordlost") {
    return next();
  } else {
    if (store.getters.isAuthenticated) {
      return next();
    } else {
      // auth missing
      if (store.state.env.environment === 'development') {
        console.log("Unauthorized access allowed for development");
        store.commit("setUser", dummyUser);
        return next();
      } else {
        return next('/');
      }
    }
  }
});

export default router;
